module.exports = __webpack_public_path__ + "img/logo-white.23569f50.svg";